    <div class="h-28 w-full bg-gray-800"></div>
    <div class="relative h-[100vh]">
        <iframe [src]="safePdfUrl" class=" w-full h-full absolute inset-0"></iframe>
    </div>

    <shell-footer/>
